//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';

import { getArtistProfile } from '@/api/artists.js';
import productEventsMixin from '@motionelements/core/src/components/mixins/product-events.mixin.js';
import ProfilePage from '@motionelements/landing-pages/src/modules/artist/ProfilePage.vue';
import CoverImage from '@/components/artists/CoverImage.vue';

export default {
  name: 'artist-profile-page',
  mixins: [productEventsMixin],
  components: {
    ProfilePage,
    CoverImage,
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
  },
  async fetch() {
    this.$store.dispatch('profile/clearFreeMediaTypes');
    await this.fetchContributor();
  },
  data() {
    return {
      artist: {
        username: '',
        description: '',
        avatar: '',
        country: '',
        html: {
          url: 'https://www.motionelements.com/',
        },
        homepage: null,
        showreel: null,
        sns: {},
        tools: [],
        banners: [],
        elements: [],
        collections: {
          total_count: 0,
        },
      },
      isLoaded: false,
    };
  },
  watch: {
    username(value) {
      if (value && value === this.artist.username) {
        window.location.href = this.$link('/contributor/page/edit').url();
      }
    },
  },
  computed: {
    ...mapState({
      username: ({ user: { member } }) => member.username,
    }),
    ...mapGetters({
      isMember: 'user/isMember',
    }),
    breadcrumbList() {
      return [
        {
          name: this.$t('term.contributors'),
          link: this.$link('/contributors').fullPath(),
        },
        {
          name: this.artist.username,
          link: this.$link(`/contributors/${this.artist.username}`).fullPath(),
          active: true,
        },
      ];
    },
  },
  methods: {
    fetchContributor() {
      return getArtistProfile(this.$route.params.username, {
        fields: {
          artist: [
            'ai_generated_content',
            'avatar',
            'banners',
            'country',
            'description',
            'element_counts',
            'homepage',
            'html.description',
            'html.title',
            'showreel',
            'sns',
            'url',
            'username',
          ].join(','),
        },
      }).then((response) => {
        const data = response.data.data;
        this.artist = data;
        return data;
      }).catch(err => {
        console.error(err);
      })
      .finally(() => {
        this.isLoaded = true;
      });
    },
    fetchContributorFollowedAt() {
      return getArtistProfile(
        this.$route.params.username,
        {
          fields: {
            artist: 'followed_at',
          },
        },
      ).then((response) => {
        const data = response.data.data;
        this.artist = {
          ...this.artist,
          ...data,
        };
        return data;
      }).catch(err => {
        console.error(err);
      });
    },
  },
  mounted() {
    // update contributor profile to check member followed_at
    if (this.isMember) {
      this.fetchContributorFollowedAt();
    }
    // redirect on mounted at client side
    if (this.username && this.username === this.artist.username) {
      window.location.href = this.$link('/contributor/page/edit').url();
    }
    this.$bus.$on('ArtistData:update-follow', status => {
      this.artist.followedAt = status ? Date.now() / 1000 : null;
      this.fetchContributor();
    });
  },
  beforeDestroy() {
    this.$bus.$off('ArtistData:update-follow');
  },
};
